<template>
  <div id="app">
    <nav style="background: violet; " class="navbar" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <div class="navbar-item">
          <router-link to="/"><img src="./assets/Feedback_box.png"></router-link>
        </div>

        <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarBasicExample" class="navbar-menu">
        <div class="navbar-start">
          <router-link style="color: rgba(0,0,200,0.6);" class="navbar-item" to="/">
            My Profile
          </router-link>
        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <router-link to="/">
              <div class="buttons">
                <a class="button is-primary" @click="change()">
                  <strong v-if="show == 0">Publish article</strong>
                  <strong v-if="show == 1">Cancel</strong>
                </a>
              </div>
            </router-link>  
          </div>
        </div>
      </div>
    </nav>

   <router-view @ublished="pubInProgress" :show.sync="show"></router-view>
  
  </div>
</template>

<script>

import { auth } from './firebase';

console.log(auth)

export default {


  name: 'App',
  data() {
      return { 
          show: 0,
          publish: "Publish article"
      }
    },
  methods: {
    change(){
      if(this.show == 0){
        this.publish = "Cancel";
        this.show = 1;
      }
      else{
        this.publish = "Publish article";
        this.show = 0; 
      }
    },
    pubInProgress(){
      this.show = 0;
    }
  },
  computed: {

  }
}
</script>

<style>
    /* The Modal (background) */
  .modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    padding-top: 60px;
  }

  html{
    font-family: 'Fredoka One', 'jubilat';
    font-weight: bold;
  }
  
  h1 {
      color: rgba(0,0,200,0.6);
      text-align: center;
      font-family:'Fredoka One', 'jubilat', 'helvetica neue', helvetica, sans-serif;
    }
  
  button {
      font-family: 'Fredoka One';
      letter-spacing: 1px;
      text-transform: uppercase;
      text-align: center;
      border: 2px solid rgba(0,0,200,0.6);
      background: darkviolet;
      color: violet;
      box-shadow: 1px 1px 2px rgba(0,0,200,0.4);
      border-radius: 20px;
      padding: 3px 10px;
      cursor: pointer;
      width: 100%;
    }
  
  table {
      width: 100%;
    }
  
  td {
      text-align: center;
    }
  
  /* For page header */
  .header {
      background: violet;
    }
  
  .menu
    {
      width: 100%;
      background: rgba(0,0,200,0.6);
      z-index: 999;
      color: violet;
      font-family: 'helvetica neue', helvetica, sans-serif;
    }
  
    a 
    { 
      font-family: 'Fredoka One', 'jubilat';
      color: inherit;
    }
  
    button:hover{
      color: white;
    }
    p {
      text-align: justiy;
    }
    .links {
      margin-right: 20px;
    }
    .fullCard {
      border: 1px solid rgba(0,0,200,0.4);
      border-radius: 10px;
      margin: 10px 5px;
      padding: 4px;
      /* position: relative; */
      top: 100px;
      /* left: 33.33%; */
      /* width: 33.33%; */
      box-shadow: 2px 2px 4px white;
      color: violet;
      background-color: rgba(0, 0, 200, 0.4);
    }
    .cardContent {
      padding: 0px;
    }
    .cardText {
      text-align: center;
    }
    a:hover{
      color: white;
    }

    a:link {
      text-decoration: none;
    }
  
    #navbar1 {
      position: fixed;
      top : 85px;
      /* top: 0;
      left: 0;
      width: 100%; */
    }
  
    footer {
      background-color: violet;
      color: rgba(0,0,200,0.6);
      padding: 0.5em;
      position: relative;
    }

  .container {
    position: relative;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-gap: 2rem;
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    margin-bottom: 6rem;
  }

  #comment{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-gap: 2rem;
  }

  body{
    color: violet;
  }

</style>
